{
    "DocumentViewer_AcceptButton": "Aceitar",
    "DocumentViewer_CloseButton": "Fechar",
    "NAME": "DocumentViewer"
}